import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogTitle,
  ogDescription,
  ogImage,
  schema,
}: SEOHeadProps) {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = title || '开云体育 - 官方正品体育平台';
    const pageDescription = description || '开云体育是领先的综合体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技数据及专业服务。';
    const pageKeywords = keywords || '开云体育,开云体育官网,开云体育平台,体育资讯,赛事直播';
    const canonical = canonicalPath
      ? `https://www.kaiyunsports.com${canonicalPath}`
      : `https://www.kaiyunsports.com${location.pathname}`;
    const ogPageTitle = ogTitle || pageTitle;
    const ogPageDescription = ogDescription || pageDescription;

    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('keywords', pageKeywords);
    setMeta('og:title', ogPageTitle, true);
    setMeta('og:description', ogPageDescription, true);
    setMeta('og:url', canonical, true);
    setMeta('twitter:title', ogPageTitle);
    setMeta('twitter:description', ogPageDescription);

    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkEl) {
      linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute('href', canonical);

    let scriptEl: HTMLScriptElement | null = null;
    if (schema) {
      const jsonLd = Array.isArray(schema) ? schema : [schema];
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.textContent = JSON.stringify(jsonLd.length === 1 ? jsonLd[0] : jsonLd);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl) {
        document.head.removeChild(scriptEl);
      }
    };
  }, [title, description, keywords, canonicalPath, ogTitle, ogDescription, ogImage, schema, location.pathname]);

  return null;
}